import React from 'react';
import { STATS } from '../mock';

const Stats = () => {
  return (
    <section className="section bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="bg-[#0A1628] rounded-3xl p-8 md:p-14 relative overflow-hidden">
          <div className="absolute -top-12 -right-12 w-56 h-56 rounded-full bg-[#D4A24C]/15 blur-2xl" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 rounded-full bg-[#D4A24C]/10 blur-xl" />
          <div className="relative grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="text-white">
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4A24C]">A trusted network</span>
              <h2 className="mt-3 text-4xl md:text-5xl font-extrabold leading-tight">
                We work with 20,000+ vetted carriers nationwide.
              </h2>
              <p className="mt-4 text-white/80 text-lg">
                Every carrier is thoroughly screened for insurance, licensing and performance — so you can ship with confidence.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {STATS.map((s, i) => (
                <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
                  <div className={`text-3xl md:text-4xl font-extrabold ${i % 2 === 0 ? 'text-[#2AA8E8]' : 'text-[#D4A24C]'}`}>{s.value}</div>
                  <div className="mt-1 font-bold text-white text-sm">{s.label}</div>
                  <div className="mt-1 text-xs text-white/60">{s.sub}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
